import React from "react";
import logoC1 from "../assets/logo-c1.jpg";
import logoC2 from "../assets/logo-c2.jpg";

// Small square mark shown on each project row / mini card.
// U-M EHS and FoodFight use a photo mark; Retail & Business and Personal
// use a simple line icon; anything unrecognized falls back to initials.
function LogoMark({ companyId, fallback }) {
  if (companyId === "c1") {
    return <img src={logoC1} alt="" />;
  }
  if (companyId === "c2") {
    return <img src={logoC2} alt="" />;
  }
  if (companyId === "c3") {
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M3 9l1-5h16l1 5" />
        <path d="M3 9h18v11a1 1 0 01-1 1H4a1 1 0 01-1-1z" />
        <path d="M9 21V12h6v9" />
      </svg>
    );
  }
  if (companyId === "c4") {
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    );
  }
  return <>{fallback}</>;
}

export default LogoMark;
